









import { Component, Vue } from 'vue-property-decorator'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FormError from '@/components/reusable-components/form/FormError.vue'
import { ValidationResult } from 'vee-validate/dist/types/types'

@Component({
    components: { FormError, ValidationObserver, ValidationProvider },
})
export default class BaseForm extends Vue {
    $refs!: {
        form: any
    }

    async onSubmit() {
        await this.$emit('check')
        const success: ValidationResult = this.$refs.form.validate()
        if (!success) {
            return
        }

        await this.$emit('submit')
    }

    validate(args: { silent: boolean }) {
        this.$refs.form.validate(args)
    }

    reset() {
        this.$refs.form.reset()
    }

    setErrors(args: Record<string, string | string[]>) {
        this.$refs.form.setErrors(args)
    }
}
